import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  deleteDocuments,
  getDocumentsId,
} from "../../redux/actions/actionDocument";
import Swal from "sweetalert2";
import { format } from "date-fns";

export default function DeleteDoc() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const documentId = useSelector((state) => state.documents.documentsDetail);
  const { id } = useParams();

  useEffect(() => {
    dispatch(getDocumentsId(id));
  }, [dispatch, id]);

  console.log(documentId);

  const handleDelete = async (e) => {
    await Swal.fire({
      title: "¿Seguro desea borrar este documento?",
      showCancelButton: true,
      confirmButtonText: "Borrar",
      denyButtonText: `Cancelar`,
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteDocuments(id));
      }
      Swal.fire("Documento Borrado");
    });
    navigate("/documentos/delete");
    console.log(e.target.value);
  };

  return (
    <div className="min-w-full bg-gray-900">
        <div className="container m-8 text-orange-500 text-[10pt] font-bold">
      <div className="text-xl pb-8 underline">Documento a Borrar</div>
      <div className="flex w-3/3 mt-6 border-b-2 border-slate-500 pb-2">
        <div className="w-60">Documento N°: {documentId.numberDocument}</div>
        <div className="w-60">
          Estado: {documentId.parcial === true ? "Parcial" : (documentId.state === false ? "No Saldado" : "Saldado") }
        </div>
      </div>
      <div>
        {documentId.client_id === undefined ? (
          <div className="flex">Sin datos</div>
        ) : (
          <div>
            <div className="w-full py-2 pb-2 border-b-2 border-slate-500">
              <div className="flex">
                <p className="w-1/4">Cliente N°: {documentId.client_id.idClient}</p>
                <p className="w-1/4">Compañia: {documentId.client_id.nameCompañy}</p>
                <p className="w-1/4">Nombre: {documentId.client_id.name}</p>
                <p className="w-1/4">Apellido: {documentId.client_id.lastName}</p>
              </div>
              <div className="flex">
                <p className="w-1/4">Dirección: {documentId.client_id.address}</p>
                <p className="w-1/4">Ciudad: {documentId.client_id.city}</p>
                <p className="w-1/4">Telefonos: {documentId.client_id.telephoneNumber}</p>
                <p className="w-1/4">E-mail: {documentId.client_id.email}</p>
              </div>              
            </div>
            <div className="flex w-3/3 border-b-2 border-slate-500 py-2">
              <p className="w-1/3">
                Dirección de Evento: {documentId.addressEvent}
              </p>
              <p className="w-1/3">
                Fecha de Envío:{" "}
                {documentId
                  ? format(new Date(documentId.dateSend), "dd/MM/yyyy")
                  : null}
              </p>
              <p className="w-1/3">
                Fecha de Recepción:{" "}
                {documentId
                  ? format(new Date(documentId.dateReception), "dd/MM/yyyy")
                  : null}
              </p>
            </div>
            <div className="pt-4">
              <p className="font-bold text-[12pt]">Articulos</p>
            </div>
            <div className="flex w-full border-b-2 border-slate-500">
              <p className="w-1/3">Nombre</p>
              <p className="w-2/5">Descripcion</p>
              <p className="w-20 text-center">Cantidad</p>
            </div>
            <div className="">
              {documentId.quantityItems.map((e, index) => {
                return (
                  <div
                    key={index}
                    className="flex border-b-2 border-slate-500 text-[9pt]"
                  >
                    <div className="w-1/3">{e.name}</div>
                    <div className="w-2/5">{e.descrip}</div>
                    <div className="w-20 text-center">
                      {e.quantity}
                    </div>
                  </div>
                );
              })}
            </div>
            <button
              onClick={handleDelete}
              className="mt-12 p-4 rounded bg-red-500 text-white  hover:bg-red-700"
            >
              Borrar
            </button>
          </div>
        )}
      </div>
      </div>
    </div>
  );
}
